<template>
  <div class="barrage-list">
    <el-card>
      <template slot="header">
        <div class="card-header">
          <span>弹幕管理</span>
        </div>
      </template>
      <el-table :data="barrageList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="pk_id" label="PK ID" width="120" />
        <el-table-column prop="user_id" label="用户ID" width="120" />
        <el-table-column prop="content" label="留言内容" />
        <el-table-column prop="vote_type" label="投票类型" width="100">
          <template slot-scope="scope">
            {{ getVoteType(scope.row.vote_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="like_count" label="点赞数" width="100" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            {{ scope.row.status === 1 ? '显示' : '隐藏' }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'BarrageList',
  data() {
    return {
      barrageList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.fetchBarrageList()
  },
  methods: {
    fetchBarrageList() {
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/barrage/list?page=${this.currentPage}&pageSize=${this.pageSize}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.barrageList = data.data.list
          this.total = data.data.total
        }
      })
      .catch(() => {
        this.$message.error('获取弹幕列表失败')
      })
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchBarrageList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchBarrageList()
    },
    handleDelete(id) {
      this.$confirm('确定要删除这条弹幕吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/barrage/delete/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchBarrageList()
          } else {
            this.$message.error(data.message || '删除失败')
          }
        })
        .catch(() => {
          this.$message.error('删除失败')
        })
      })
      .catch(() => {})
    },
    getVoteType(type) {
      const typeMap = {
        1: '相信',
        2: '不相信'
      }
      return typeMap[type] || '未知'
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.barrage-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>